import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=16578f03&scoped=true&lang=pug&"
import script from "./Persons.vue?vue&type=script&lang=js&"
export * from "./Persons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16578f03",
  null
  
)

export default component.exports